const _ = require('lodash');

export class StyleService {
	private _styles: any;

	private elementsClassesNames: any = {
		privacyButton: [
			'.user-centric-corner-modal .card-footer .btn-primary',
			'.user-centric-center-modal .secondary-basic .uc-save-settings-button',
			'.user-centric-center-modal .secondary-advance .uc-save-settings-button'
		],
		acceptButton: [
			'.user-centric-center-modal .primary .accept-settings-btn',
			'.uc-banner-content .uc-btn-primary'
		],
		denyButton: [
			'.user-centric-center-modal .primary .deny-settings-btn',
			'.uc-banner-content .btn-deny'
		],
		textOptInMessage: [
			//todo
		],
		moreInfoButton: [
			'.user-centric-center-modal .primary .more-info-button',
			'.uc-banner-content .more-info-button'
		],
		mainButton: [
			'.uc-corner-modal .uc-corner-modal-content .uc-card-header',
			'.uc-corner-modal .uc-corner-modal-content .uc-nav-tabs',
			'.usercentrics-button .uc-dropdown .uc-dropdown-menu',
			'.usercentrics-button .uc-card-footer .uc-btn.uc-btn-primary'
		],
		mainButtonFill: [
			'.layout-11 .user-centric-corner-modal .uc-consent-info-modal svg g path'
		]
	};

	constructor() { }

	public get styles() {
		return this._styles;
	}

	public set styles(_styles) {
		this._styles = _styles;
		// this.setupStyles();
		this.specialStyles();
	}

	private setupStyles() {
		let self = this;
		let mainWrapper = document.getElementById('usercentrics-button');

		let privacyButtonsClassNames = this.elementsClassesNames.privacyButton;
		_.forEach(privacyButtonsClassNames, privacyBtnClassName => {
			let privacyBtns = mainWrapper.querySelectorAll(privacyBtnClassName);
			_.forEach(privacyBtns, privacyBtn => {
				if (privacyBtn) {
					let style =
						self.getStyleString(
							'opacity',
							self.styles.btnPrivacyButtonTransparency
						) +
						self.getStyleString(
							'color',
							self.styles.btnPrivacyButtonTextColor
						) +
						self.getStyleString(
							'background-color',
							self.styles.btnPrivacyButtonBgColor
						);

					privacyBtn.setAttribute('style', style);
				}
			});
		});

		// let acceptButtonsClassNames = this.elementsClassesNames.acceptButton;
		// _.forEach(acceptButtonsClassNames, acceptBtnClassName => {
		//   let acceptBtns = mainWrapper.querySelectorAll(acceptBtnClassName);
		//   _.forEach(acceptBtns, acceptBtn => {
		//     if (acceptBtn) {
		//       let style =
		//         self.getStyleString('color', '#' + self.styles.btnAcceptTextColor) +
		//         self.getStyleString(
		//           'background-color',
		//           '#' + self.styles.btnAcceptBgColor
		//         );

		//       acceptBtn.setAttribute('style', style);
		//     }
		//   });
		// });

		// let denyButtonsClassNames = this.elementsClassesNames.denyButton;
		// _.forEach(denyButtonsClassNames, denyBtnClassName => {
		//   let denyBtns = mainWrapper.querySelectorAll(denyBtnClassName);
		//   _.forEach(denyBtns, denyBtn => {
		//     if (denyBtn) {
		//       let style =
		//         self.getStyleString('color', '#' + self.styles.btnDenyTextColor) +
		//         self.getStyleString(
		//           'background-color',
		//           '#' + self.styles.btnDenyBgColor
		//         );

		//       denyBtn.setAttribute('style', style);
		//     }
		//   });
		// });

		// let moreInfoButtonsClassNames = this.elementsClassesNames.moreInfoButton;
		// _.forEach(moreInfoButtonsClassNames, moreInfoBtnClassName => {
		//   let moreInfoBtns = mainWrapper.querySelectorAll(moreInfoBtnClassName);
		//   _.forEach(moreInfoBtns, moreInfoBtn => {
		//     if (moreInfoBtn) {
		//       let style =
		//         self.getStyleString(
		//           'color',
		//           '#' + self.styles.btnMoreInfoTextColor
		//         ) +
		//         self.getStyleString(
		//           'background-color',
		//           '#' + self.styles.btnMoreInfoBgColor
		//         );

		//       moreInfoBtn.setAttribute('style', style);
		//     }
		//   });
		// });

		let mainButtonClassNames = this.elementsClassesNames.mainButton;
		_.forEach(mainButtonClassNames, mainButtonClassName => {
			let mainBtns = mainWrapper.querySelectorAll(mainButtonClassName);
			_.forEach(mainBtns, mainBtn => {
				if (mainBtn) {
					let style = self.getStyleString(
						'background-color',
						'#' + self.styles.btnPrivacyButtonBgColor
					);

					mainBtn.setAttribute('style', style);
				}
			});
		});

		let mainButtonFillClassNames = this.elementsClassesNames.mainButtonFill;
		_.forEach(mainButtonFillClassNames, mainButtonFillClassName => {
			let mainBtns = mainWrapper.querySelectorAll(mainButtonFillClassName);
			_.forEach(mainBtns, mainBtn => {
				if (mainBtn) {
					let style = self.getStyleString(
						'fill',
						'#' + self.styles.btnPrivacyButtonBgColor
					);

					mainBtn.setAttribute('style', style);
				}
			});
		});
	}

	private getStyleString(style, value) {
		let result = '';
		if (value) {
			result = style + ': ' + value + '; ';
		}
		return result;
	}

	static injectClientCss(styleCss, layout) {
		styleCss = styleCss.trim();
		if (styleCss[styleCss.length - 1] === '}') {
			// const selector = '.usercentrics-button.' + layout ;
			const filterFunc = a => a.length;
			const splitBy = '} ';
			let preparedCss = styleCss // selector
				.split(splitBy)
				.filter(filterFunc)
				.join(splitBy); // + selector);
			const node = document.createElement('style');
			node.type = 'text/css';
			node.innerHTML = preparedCss;
			document.head.appendChild(node);
		} else {
			const node = document.createElement('link');
			node.type = 'text/css';
			node.rel = 'stylesheet';
			node.href = styleCss;
			document.head.appendChild(node);
		}
	}

	specialStyles() {
		let preparedCss = `#uc-corner-modal a[href], #uc-center-modal a[href], #uc-banner-modal a[href], #uc-central-banner-modal a[href] {
      color: #${
			this.styles.linkColor ? this.styles.linkColor : '0096ff'
			} !important;
    }`;
		const node = document.createElement('style');
		node.type = 'text/css';
		node.id = 'uc-specialStyle';
		node.innerHTML = preparedCss;
		let existingTag = document.getElementById(node.id);
		if (existingTag) {
			existingTag.innerHTML = preparedCss;
		} else {
			document.head.appendChild(node);
		}
	}
}
